import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const PupilReducer = combineReducers({
  fetchRequest: createRequestReducer('PUPIL_STORE:FETCHING'),
  pupil: createReducer(null, {
    'PUPIL_STORE:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      response.data
  })
})

export default PupilReducer
